<template>
  <tutorial-main @back="goBack">
    <template slot="nav">
      <div class="tutorialNav">
        <p :title="detail.title">{{detail.title}}</p>
        <!--<div class="btn">
          <span>分享</span>
        </div>
        <img src="@/assets/images/org_logo.png" alt="">-->
        <div class="btns"
             v-if="user.show_excellent==1">
          <div v-if="detail.is_excellent==0"
               class="btn"
               @click="changeExcellent(1)">设为优秀教案
          </div>
          <div v-else
               class="btn"
               @click="changeExcellent(0)">取消优秀教案
          </div>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="tutorialMain">
        <vue-scroll :ops="ops" v-if="showData">
          <div class="contentWrap">
            <div class="content">
              <div class="contentUp">
                <div v-if="user.is_owner"
                     class="detail self">
                  <div class="detailUp line" v-if="user.plan_title_exam">
                    <p style="color: #f88594;">
                      考试教案题目：{{user.plan_title_exam}}
                    </p>
                  </div>
                  <div class="detailUp line">
                    <p>分类：{{detail.plan_category_name}}</p>
                    <p>难度 ：{{detail.zh}}</p>
                    <!--<p v-if="detail.session_start_time > '0'">开始时间 / {{detail.session_start_time | time}}</p>-->
                    <!--<p v-else>开始时间 / &#45;&#45;</p>-->
                    <p>最后更新时间：{{detail.last_updated | time}}</p>
                  </div>
                  <div class="detailDown line" v-if="user.is_edit === 1" >
                    <!--<div class="iconWrap">
                      <v-icon name="regular/copy"
                              scale="1.2"></v-icon>
                    </div>-->
                    <div class="iconWrap"
                         title="下载"
                         @click="downloadPDF">
                      <v-icon name="regular/arrow-alt-circle-down"
                              scale="1.2"></v-icon>
                    </div>
                    <a v-show="false"
                       ref="download_btn"
                       :href="pdf_url"
                       download=""></a>
                    <div class="iconWrap"
                         title="编辑"
                         @click="editTutorial">
                      <v-icon name="regular/edit"
                              scale="1.2"></v-icon>
                    </div>
                    <div class="iconWrap"
                         title="删除"
                         @click="delTutorial" >
                      <v-icon name="regular/trash-alt"
                              scale="1.2"></v-icon>
                    </div>
                    <div class="type"  v-if="detail.c_id !=0 && user.class_train_type !=='continue_education'">
                      <p>类型</p>
                      <select v-model="detail.session_type"
                              @change="changeType">
                        <option value="practice">实践教案</option>
                        <option value="exam">考试教案</option>
                      </select>
                    </div>
                    <div class="type sharing_status" v-if="detail.session_type==='practice' && detail.c_id !=0">
                      <p>共享状态</p>
                      <select v-model="detail.sharing_status"
                              @change="changeStatus">
                        <option value="Public">完全公开</option>
                        <option value="Club">教师公开</option>
                      </select>
                    </div>
                  </div>
                  <template v-if="user.is_owner === 1 && detail.category_id === 52">
                    <div class="FIFA" >
                      <p>同班学员评价：</p>
                      <el-tag
                              :key="tag"
                              v-for="tag in dynamicTagsStu"
                              closable
                              class="tag_tag"
                              style="margin:  5px"
                              :disable-transitions="false"
                              @close="handleClose(tag,'student')">
                        {{tag}}
                      </el-tag>
                      <el-input
                              class="input-new-tag"
                              v-if="inputVisibleStu"
                              v-model="inputValueStu"
                              ref="saveTagInput"
                              style="width: 150px"
                              size="small"
                              @keyup.enter.native="handleInputConfirm('student')"
                              @blur="handleInputConfirm('student')"
                      >
                      </el-input>
                      <el-button v-else class="button-new-tag" size="mini" @click="showInput('student')">添加同班学员评价</el-button>
                    </div>
                    <div class="FIFA"  >
                      <p>FIFA讲师评价：</p>
                      <el-tag
                              :key="tag"
                              v-for="tag in dynamicTagsFiFA"
                              closable
                              class="tag_tag"
                              style="margin:  5px"
                              :disable-transitions="false"
                              @close="handleClose(tag,'fifa')">
                        {{tag}}
                      </el-tag>
                      <el-input
                              class="input-new-tag"
                              v-if="inputVisibleFiFA"
                              v-model="inputValueFiFa"
                              ref="saveTagInput1"
                              style="width: 150px"
                              size="small"
                              @keyup.enter.native="handleInputConfirm('fifa')"
                              @blur="handleInputConfirm('fifa')"
                      >
                      </el-input>
                      <el-button v-else class="button-new-tag" size="mini" @click="showInput('fifa')">添加FIFA讲师评价</el-button>
                    </div>
                  </template>
                </div>
                <div v-else
                     class="detail other">
                  <div class="otherWrap">
                    <div class="left" >
                      <div class="detailUp line" v-if="user.plan_title_exam">
                        <p style="color: #f88594;">
                          考试教案题目：{{user.plan_title_exam}}
                        </p>
                      </div>
                      <div class="detailUp line">
                        <p>分类：{{detail.plan_category_name}}</p>
                        <p>难度：{{detail.zh}}</p>
                      </div>
                      <div class="detailDown line">
                        <!--<p v-if="detail.session_start_time > '0'">开始时间 / {{detail.session_start_time | time}}</p>-->
                        <!--<p v-else>开始时间 / &#45;&#45;</p>-->
                        <p>最后更新时间：{{detail.last_updated | time}}</p>
                        <div v-if="['super','system','viewer','sysFive','supFive','viewFive'].includes(userType)">
                          <div class="iconWrap"
                            title="下载"
                            @click="downloadPDF"
                            style="cursor:pointer">
                            <v-icon name="regular/arrow-alt-circle-down"
                              scale="1.2"></v-icon>
                          </div>
                          <a v-show="false"
                            ref="download_btn"
                            :href="pdf_url"
                            download=""></a>
                        </div>
                      </div>
                      <template v-if="detail.category_id === 52 ">
                        <div class="FIFA"  v-if="dynamicTagsStu.length >0 ">
                          <p>同班学员评价：</p>
                          <el-tag
                                  :key="tag"
                                  class="tag_tag"
                                  v-for="tag in dynamicTagsStu"
                                  style="margin:  5px"
                                  :disable-transitions="false"
                          >
                            {{tag}}
                          </el-tag>
                        </div>
                        <div class="FIFA" v-if="dynamicTagsFiFA.length > 0"  >
                          <p>FIFA讲师评价：</p>
                          <el-tag
                                  :key="tag"
                                  v-for="tag in dynamicTagsFiFA"
                                  class="tag_tag"
                                  style="margin:  5px"
                                  :disable-transitions="false"
                          >
                            {{tag}}
                          </el-tag>
                        </div>
                      </template>
                    </div>
                    <div class="right"
                         v-show="detail.session_type != 'yioks'"
                         style="display: none;">
                      <img :src="!user.profile_picture?userImg:user.profile_picture"
                           @error="imgErr"
                           alt="">
                      <div class="info">
                        <p class="name">{{user.user_name}}</p>
                        <p class="type" v-if="detail.c_id" >{{user.member_type | role}}</p>
                        <p v-else>讲师</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="detail.overall_description!=''"
                     class="desc">
                  <p>
                    <span>教案总体描述：</span>
                    <span v-html="detail.overall_description"></span>
                  </p>
                </div>
              </div>
              <div class="contentDown">
                <div class="left">
                  <div class="flashWrap">
                    <div class="up">
                      <p class="title">{{itemDetail.drill_title}}</p>
                      <p class="time">{{itemDetail.time_spent}}分钟</p>
                    </div>
                    <div class="down">
<!--                      <div class="flash"-->
<!--                           v-if="flashFlag">-->
<!--                        <template v-for="(item, index) in list">-->
<!--                          <object v-if="itemIdx == index" :key='item.drill_id' type="application/x-shockwave-flash"-->
<!--                                  id=""-->
<!--                                  name="sspviewer"-->
<!--                                  align="middle"-->
<!--                                  :data="`${HOSTURL}/uploads/flash-tool/yioks-football-view.swf?revision=1463`"-->
<!--                                  width="589"-->
<!--                                  height="343">-->
<!--                            <param name="quality" value="high">-->
<!--                            <param name="bgcolor" value="#000000">-->
<!--                            <param name="play" value="false">-->
<!--                            <param name="loop" value="false">-->
<!--                            <param name="wmode" value="transparent">-->
<!--                            <param name="scale" value="showall">-->
<!--                            <param name="menu" value="true">-->
<!--                            <param name="devicefont" value="false">-->
<!--                            <param name="salign" value="">-->
<!--                            <param name="allowscriptaccess" value="sameDomain">-->
<!--                            <param name="allowfullscreen" value="true">-->
<!--                            <param name="flashvars"-->
<!--                                   :value="`xmlRequestFile=/api/xml/tactical_data?non_token=1%26plan_id=${id}%26gotourl=/student/student&screenSortOrder=${itemIdx}`">-->
<!--                          </object>-->
<!--                        </template>-->
<!--                      </div>-->
                      <img class="placeholder_img"
                           :src="itemDetail.drill_id | addSrc(itemDetail.last_updated)"
                           @error="holderImgErr($event)"
                           alt="">
                      <template v-if="isShowCom">
                        <yioks-sspviewer  :screenId="itemIdx" :requestXmlUrl="`/api/xml/tactical_data?non_token=1%26plan_id=${id}%26gotourl=/student/student`" />
                      </template>
                    </div>
<!--                    <div class="flashTipsImg"-->
<!--                         v-if="!flashFlag">-->
<!--                      <a href="https://get2.adobe.com/cn/flashplayer/" style="">-->
<!--                        <img :src="icon.FlashTips" alt="">-->
<!--                      </a>-->
<!--                    </div>-->
                    <div class="flashLines">
                      <div class="lines_key" v-if="lineList.length"
                           :style='"background: url("+icon.Grass+") top left repeat;"'>
                        <div class="key block">
                          <div class="col" v-for="(item, index) in lineList">
                            <div class="line_container block" :style='"border-color:"+item._lineColor+""'>
                              <img :src='"@/assets/images/arrows/arrow_left_"+item._arrowThickness_left+".png"'
                                   width="15" height="20" alt="Arrow Large"
                                   style="position:absolute; top:0px; left:0px;"/>
                              <img
                                  :src='"@/assets/images/lines/line_"+item._lineStyle+"_"+item._lineType+"_"+item._lineThickness+".png"'
                                  width="50" height="20" alt="Line Straight 2px"
                                  style="position:absolute; top:-0px; left:15px;"/>
                              <img :src='"@/assets/images/arrows/arrow_right_"+item._arrowThickness_right+".png"'
                                   width="15" height="20" alt="Arrow Medium Right"
                                   style="position:absolute; top:-0px; left:65px;"/>
                            </div>
                            <p>{{item.name_zh}}</p>
                          </div>
                          <div class="clear"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detail">
                    <div class="nav">
                      <template v-if="itemDetail.show_learning_objectives_box == 1">
                        <p :class="{active: otherFlag}"
                           @click="showOther">环节说明</p>
                        <p :class="{active: !otherFlag}"
                           @click="showOther">学习目标</p>
                      </template>
                      <template v-else>
                        <p class="active">环节说明</p>
                      </template>
                    </div>
                    <div class="intro"
                         v-show="otherFlag"
                         v-html="itemDetail.drill_comment"></div>
                    <div class="goal"
                         v-show="!otherFlag">
                      <div class="table">
                        <div class="tr"
                             v-if="itemDetail.show_box_skills_technical">
                          <div class="td">
                            <div class="wrap">
                              <img :src="icon.Technical" alt="">
                              <p>
                                <span>技术</span>
                                <span
                                    v-if="itemDetail.show_scale_skills_technical">({{itemDetail.skills_technical}}%)</span>
                              </p>
                            </div>
                          </div>
                          <div class="td">
                            <div class="wrap">
                              <p>{{itemDetail.skills_technical_comment}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="tr"
                             v-if="itemDetail.show_box_skills_tactical">
                          <div class="td">
                            <div class="wrap">
                              <img :src="icon.Soccer" alt="">
                              <p>
                                <span>战术</span>
                                <span
                                    v-if="itemDetail.show_scale_skills_tactical">({{itemDetail.skills_tactical}}%)</span>
                              </p>
                            </div>
                          </div>
                          <div class="td">
                            <div class="wrap">
                              <p>{{itemDetail.skills_tactical_comment}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="tr"
                             v-if="itemDetail.show_box_skills_physical">
                          <div class="td">
                            <div class="wrap">
                              <img :src="icon.Physical" alt="">
                              <p>
                                <span>体能</span>
                                <span
                                    v-if="itemDetail.show_scale_skills_physical">({{itemDetail.skills_physical}}%)</span>
                              </p>
                            </div>
                          </div>
                          <div class="td">
                            <div class="wrap">
                              <p>{{itemDetail.skills_physical_comment}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="tr"
                             v-if="itemDetail.show_box_skills_psychological">
                          <div class="td">
                            <div class="wrap">
                              <img :src="icon.Heart" alt="">
                              <p>
                                <span>心理</span>
                                <span v-if="itemDetail.show_scale_skills_psychological">({{itemDetail.skills_psychological}}%)</span>
                              </p>
                            </div>
                          </div>
                          <div class="td">
                            <div class="wrap">
                              <p>{{itemDetail.skills_psychological_comment}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="tr"
                             v-if="itemDetail.show_box_skills_social">
                          <div class="td">
                            <div class="wrap">
                              <img :src="icon.HandShake" alt="">
                              <p>
                                <span>交流情商</span>
                                <span v-if="itemDetail.show_scale_skills_social">({{itemDetail.skills_social}}%)</span>
                              </p>
                            </div>
                          </div>
                          <div class="td">
                            <div class="wrap">
                              <p>{{itemDetail.skills_social_comment}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <p>全部环节</p>
                  <p v-for="(item, index) in list"
                     :class="{item: true, active: itemIdx == index}"
                     :key="index"
                     @click="switchTab(item.drill_title, index)">
                    <span>{{item.drill_title}}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </vue-scroll>
        <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
        <yioks-tips :showTips="delTipsFlag"
                    :tips="`确定删除该教案吗？`"
                    @hideTips="hideDelTips"></yioks-tips>
        <excellent-tips :showTips="greetTipsFlag"
                        :tips="tipsMsg"
                        @hideTips="hideGreetTips"></excellent-tips>
      </div>
    </template>
  </tutorial-main>
</template>

<script>
  /* 教案详情 */
  import "vue-awesome/icons/regular/copy";
  import "vue-awesome/icons/regular/arrow-alt-circle-down";
  import "vue-awesome/icons/regular/edit";
  import "vue-awesome/icons/regular/trash-alt";

  import ops from '@/assets/js/vuescrollOption';
  import {roleType} from "@/assets/js/status";
  import {
    tutorialDetail,
    excellentTutorial,
    downloadTutorial,
    deleteTutorial,
    tutorialType,
    tutorialStatus
  } from "@/api/training_student/api";
  import {storageData} from "@/assets/js/storage";
  import {plan_make_tag} from "@/api/common/api";
  import Default from "@/assets/images/person.png";
  import Technical from "@/assets/images/tutorial-detail/technical.png";
  import Soccer from "@/assets/images/tutorial-detail/soccer.png";
  import Physical from "@/assets/images/tutorial-detail/physical.png";
  import Heart from "@/assets/images/tutorial-detail/heart.png";
  import HandShake from "@/assets/images/tutorial-detail/handshake.png";
  import FlashTips from "@/assets/images/tutorial-detail/flash_tips.png";
  import Grass from "@/assets/images/grass.gif";
  import placeHolderImg from "@/assets/images/plan_default_big.jpg";
  import fiveMixins from '@/minix/fiveMixins';

  export default {
    name: "tutorial-detail",
    beforeRouteEnter(to, from, next) {
      // console.log(from);
      if (from.query.goto) {
        // console.log("编辑 路由 跳转进来");
        next((vm) => {
          vm.routerFlag = false;
          vm.routerPath = from.query.goto.replace(/@/g, "&");
          // console.log(vm.routerPath);
        });
      }
      else if (window.location.search.indexOf('goto=') !== -1) {
        // console.log("编辑 非路由 跳转进来");
        // console.log(window.location);
        next((vm) => {
          vm.routerFlag = false;
          vm.routerPath = window.decodeURIComponent(window.location.search.slice(window.location.search.indexOf('goto=') + 5).replace(/@/g, "&"));
          // console.log(vm.routerPath);
        });
      }
      else {
        // console.log("路由跳转进来");
        next((vm) => {
          vm.routerFlag = true;
          vm.routerPath = from.fullPath.replace(/&/g, "@");
          // console.log(vm.routerPath);
        });
      }
    },
    mixins: [fiveMixins],
    data() {
      return {
        isShowCom: true,
        routerFlag: false,
        dynamicTagsFiFA: [],
        dynamicTagsStu: [],
        inputVisibleStu: false,
        inputVisibleFiFA: false,
        inputValueStu: '',
        inputValueFiFa: '',
        routerPath: "",
        userType: storageData.getUserInfo().member_type,
        HOSTURL: process.env.VUE_APP_URL,
        ops: ops(),
        userImg: Default,
        flashFlag: false,
        id: this.$route.query.id || this.$route.params.id,
        list: [],
        lineList: [],
        showData: false,
        user: {},
        detail: {},
        pdf_url: "",
        itemIdx: 0,
        itemDetail: {},
        otherFlag: true,
        icon: {
          Technical,
          Soccer,
          Physical,
          Heart,
          HandShake,
          FlashTips,
          Grass
        },
        delTipsFlag: false,
        greetStatus: null,
        greetTipsFlag: false,
        tipsMsg: "",
        greetTipsMsg: ["确认取消优秀教案？", "确认设为优秀教案？"],
        downPdfFlag: false,
      };
    },
    components: {
      "tutorial-main": () => import("@/components/LayOut/Common/up-down"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
      "excellent-tips": () => import("@/components/Tips/Dialog"),
      "yioks-sspviewer": () => import("@/components/sspViewer/sppCanvas")
    },
    filters: {
      role(type) {
        return roleType(type);
      },
      addSrc(id, last_updated) {
        return `${process.env.VUE_APP_URL}/uploads/library/${id}.jpg?v=${last_updated}`;
      },
    },
    created() {
      this.flashFlag = this.$yioks.flashChecker();
      this.getDetail();
    },
    methods: {
      goBack() {
        // this.$router.go(-1);
        // console.log(this.routerFlag);
        if (this.routerFlag) {
          // console.log("name或path跳转出去");
          this.$router.go(-1);
        } else {
          // console.log("编辑 路由 跳转出去");
          // console.log(this.routerPath);
          this.$router.push(this.routerPath);
        }
      },
      getDetail() {
        tutorialDetail({plan_id: this.id})
          .then((res) => {
            // console.log(res);
            const {status} = res.data;
            if (Number(status) === 0) {
              const {plan, user, library} = res.data.result;
              this.showData = Boolean(plan.length > 0);
              this.user = user;
              this.list = plan;
              this.lineList = library.lineList;
              this.detail = plan[0];
              this.dynamicTagsStu= plan[0].students_tags ? JSON.parse(plan[0].students_tags) : [];
              this.dynamicTagsFiFA=plan[0].fifa_tags ? JSON.parse(plan[0].fifa_tags) :[];
              this.itemDetail = plan[this.itemIdx];
            }
          })
          .catch((err) => {
            console.error(err);
          });
      },
      changeExcellent(status) {
        this.tipsMsg = this.greetTipsMsg[status];
        this.greetStatus = status;
        this.greetTipsFlag = true;
      },
      hideGreetTips(bool, sure) {
        this.greetTipsFlag = bool;
        if (sure) {
          // status==0 取消优秀教案 status==1 设为优秀教案
          excellentTutorial({plan_id: this.id, status: this.greetStatus})
            .then((res) => {
              // console.log(res);
              if (Number(res.data.status) === 0) {
                this.greetStatus == 0
                  ? this.$set(this.detail, "is_excellent", 0)
                  : this.$set(this.detail, "is_excellent", 1);
                this.$message.success("修改成功！");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else {

        }
      },
      downloadPDF() {
        if(this.downPdfFlag) return false;
        this.downPdfFlag = true;
        downloadTutorial({plan_id: this.id})
          .then((res) => {
            // console.log(res);
            const {status} = res.data;
            if (Number(status) === 0) {
              this.pdf_url = res.data.result.pdf_url;
              this.$nextTick(() => {
                this.$refs.download_btn.click();
              });
            }
            this.downPdfFlag = false;
          })
          .catch((err) => {
            this.downPdfFlag = false;
            console.error(err);
          });
      },
      changeType() {
        tutorialType({plan_id: this.id, session_type: this.detail.session_type})
          .then((res) => {
            const {status, msg} = res.data;
            Number(status) === 0
              ? this.$message.success("修改成功！")
              : this.$message.error(msg);
            this.getDetail();
          })
          .catch((err) => {
            console.error(err);
          });
      },
      changeStatus() {
        tutorialStatus({plan_id: this.id, sharing_status: this.detail.sharing_status})
          .then((res) => {
            const {status, msg} = res.data;
            Number(status) === 0
              ? this.$message.success("修改成功！")
              : this.$message.error(msg);
          })
          .catch((err) => {
            console.error(err);
          });
      },
      editTutorial() {
        const ua = navigator.userAgent;
        const userInfo = this.$store.state.userInfo;
        const userType = this.isFive ? 'five' : 'eleven';
        if(this.detail.c_id === 0) {
          window.location.href = `/static/session_editor/sspeditorEdit.html?plan_id=${this.id}&type=${userInfo.member_type}&tutorial_uid=${userInfo.uid}&goto=${this.routerPath}&userType=${userType}`
        } else  {
          window.location.href = `/static/session_editor/sspeditorEdit.html?plan_id=${this.id}&type=${userInfo.member_type}&tutorial_uid=${userInfo.uid}&goto=${this.routerPath}&userType=${userType}`
        }
        // if (ua.indexOf("Chrome") > -1) {
        //   if (window.top !== window) {
        //     let _protocol = window.location.protocol;
        //     if(_protocol.indexOf(":") == -1)_protocol=_protocol+":";
        //     if (this.detail.c_id ==0){
        //       // window.top.location.href = _protocol + "//" + window.location.host + `/teacher/edit_tutorial?plan_id=${this.id}&goto=${this.routerPath}&type=teacher`
        //       window.location.href = `/static/sspeditorEdit.html?plan_id=${this.id}&goto=${this.routerPath}&type=teacher`
        //     }else{
        //       // this.$router.push({
        //       //   path: "edit_tutorial",
        //       //   query: {
        //       //     plan_id: this.id,
        //       //     goto: this.routerPath,
        //       //   }
        //       // });
        //       window.location.href = `/static/sspeditorEdit.html?plan_id=${this.id}&goto=${this.routerPath}`
        //     }
        //
        //   }else{
        //     if(this.detail.c_id ==0 ){
        //       this.$router.push({
        //         path: "edit_tutorial",
        //         query: {
        //           plan_id: this.id,
        //           goto: this.routerPath,
        //           type:'teacher'
        //         }
        //       });
        //       window.location.href = `/static/sspeditorEdit.html?plan_id=${this.id}&goto=${this.routerPath}&type=teacher`
        //     }else{
        //       this.$router.push({
        //         path: "edit_tutorial",
        //         query: {
        //           plan_id: this.id,
        //           goto: this.routerPath,
        //         }
        //       });
        //     }
        //   }
        // }else{
        //   if(this.detail.c_id ==0 ){
        //     this.$router.push({
        //       path: "edit_tutorial",
        //       query: {
        //         plan_id: this.id,
        //         goto: this.routerPath,
        //         type:'teacher'
        //       }
        //     });
        //   }else{
        //     this.$router.push({
        //       path: "edit_tutorial",
        //       query: {
        //         plan_id: this.id,
        //         goto: this.routerPath,
        //       }
        //     });
        //   }
        // }
      },
      delTutorial() {
        this.delTipsFlag = true;
      },
      hideDelTips(bool, sure) {
        this.delTipsFlag = bool;
        if (sure) {
          deleteTutorial({plan_id: this.id})
            .then((res) => {
              // console.log(res);
              const {status, msg} = res.data;
              if (Number(status) === 0) {
                if(this.user.class_train_type  === 'continue_education'){ // 继续教育 跳首页去
                  this.$router.push({ path: "class_detail"});
                }else{
                  this.$router.push(decodeURIComponent(this.routerPath));
                }
                
              } else {
                this.$message.error(msg);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else {

        }
      },
      imgErr() {
        this.$set(this.user, "profile_picture", this.userImg);
      },
      holderImgErr(e) {
        e.target.src = placeHolderImg;
      },
      switchTab(name, idx) {
        // this.itemDetail = this.list[idx];
        this.isShowCom = false;
        // this.itemIdx = idx;
        this.$nextTick(() =>{
          this.itemDetail = this.list[idx];
          this.itemIdx = idx;
          this.isShowCom = true;
        })
      },
      showOther() {
        this.otherFlag = !this.otherFlag;
      },
      handleClose(tag,type) {
        if (type==='student'){
          let arr =this.dynamicTagsStu.slice();
          arr.splice(arr.indexOf(tag), 1);
          // this.dynamicTagsStu.splice(this.dynamicTagsStu.indexOf(tag), 1);
          plan_make_tag({
            plan_id:this.detail.plan_id,
            tags: JSON.stringify(arr),
            type,
          }).then(res=>{
            if(res.data.status ==0){
              this.dynamicTagsStu.splice(this.dynamicTagsStu.indexOf(tag), 1)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        } else{
          let arr =this.dynamicTagsFiFA.slice();
          arr.splice(arr.indexOf(tag), 1);
          // this.dynamicTagsFiFA.splice(this.dynamicTagsFiFA.indexOf(tag), 1);
          plan_make_tag({
            plan_id:this.detail.plan_id,
            tags: JSON.stringify(arr),
            type,
          }).then(res=>{
            if (res.data.status ==0){
              this.dynamicTagsFiFA.splice(this.dynamicTagsFiFA.indexOf(tag), 1)
            } else{
              this.$message.error(res.data.msg)
            }
          })
        }
      },

      showInput(type) {
        if (type ==='student'){
          this.inputVisibleStu = true;
          this.$nextTick( ()=> {
            this.$refs.saveTagInput.$refs.input.focus();
          });
        }else{
          this.inputVisibleFiFA = true;
          this.$nextTick( ()=> {
            this.$refs.saveTagInput1.$refs.input.focus();
          });
        }

      },
      handleInputConfirm(type) {
        if (type === 'student'){
          let inputValue = this.inputValueStu;
          if (inputValue ) {
            let arr =this.dynamicTagsStu.slice();
            arr.push(inputValue);
            // this.dynamicTagsStu.push(inputValue);//
            plan_make_tag({
              plan_id:this.detail.plan_id,
              tags: JSON.stringify(arr),
              type,
            }).then(res=>{
              if (res.data.status == 0){
                this.dynamicTagsStu.push(inputValue);
                this.inputVisibleStu = false;
                this.inputValueStu = '';
               return
              }else{
                this.$message.error(res.data.msg)
              }
            })
          }
          this.inputVisibleStu = false;
          this.inputValueStu = '';
        }else{
          let inputValue = this.inputValueFiFa;
          if (inputValue ) {
            let arr =this.dynamicTagsFiFA.slice();
            arr.push(inputValue);
            // this.dynamicTagsFiFA.push(inputValue);
            plan_make_tag({
              plan_id:this.detail.plan_id,
              tags: JSON.stringify(arr),
              type,
            }).then(res=>{
              if (res.data.status == 0 ) {
                this.dynamicTagsFiFA.push(inputValue)
                this.inputVisibleFiFA = false;
                this.inputValueFiFa = '';
                return
              }else{
                this.$message.error(res.data.msg)
              }
            })
          }
          this.inputVisibleFiFA = false;
          this.inputValueFiFa = '';
        }

      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";

  .tutorialNav {
    flex: 1 1 auto;
    position: relative;
    padding: 0 20px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: $font_size_big;
    p {
      max-width: 335px;
      over_hide();
    }
    
    .btns {
      .btn {
        margin: 0 0 0 10px;
        padding: 6px 10px;
        background-color: $color_err;
        cursor: pointer;
      }
    }
  }

  .tutorialMain {
    width: 890px;
    height: 100%;
    padding: 10px 0;
    background-color: $block_bg_color_base;
    .contentWrap {
      .content {
        padding: 0 35px;
        font-size: $font_size_medium;
        .contentUp {
          .detail {
            border-bottom: 1px solid $color_white;
            /* ----start-----不同角色共用 */
            .line {
              height: 25px;
              margin: 15px 0;
              display: flex;
              align-items: center;
            }
            .FIFA{
              margin: 15px 0;
              display: flex;
              align-items: center;
              flex-wrap: wrap
            }
            .detailUp,.detailDown {
              p {
                margin: 0 25px 0 0;
              }
            }
            .detailUp :last-child,.detailDown :last-child {
              margin: 0;
            }
            /* ----end-----不同角色共用 */
            &.self {
              .detailDown {
                user-select none;
                .iconWrap {
                  margin: 0 20px 0 0;
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                }
                .type {
                  height: 100%;
                  display: flex;
                  align-items: center;
                  select {
                    height: 100%;
                    margin: 0 0 0 10px;
                    color: $color_black;
                    font-size: $font_size_base;
                  }
                }
                .sharing_status {
                  margin-left: 20px;
                }

              }
            }
            &.other {
              padding: 0 0 10px 0;
              .otherWrap {
                display: flex;
                justify-content: space-between;
                .right {
                  max-width: 275px;
                  /*margin: 0 20px 0 0 ;*/
                  min-width 170px
                  display: flex;
                  align-items: center;
                  img {
                    width: 90px;
                    height: 90px;
                    margin: 0 15px 0 0;
                    border-radius: 50%;
                  }
                  .info {
                    .name {
                      font-size: $font_size_medium;
                      font-weight: bolder;
                    }
                    .type {
                      font-size: $font_size_medium;
                    }
                  }
                }
              }
            }
          }
          .desc {
            padding: 15px 0 20px;
            line-height: 30px;
            border-bottom: 1px solid $color_white;
          }
        }
        .contentDown {
          padding: 10px 0 0;
          display: flex;
          .left {
            width: 75%;
            padding: 0 20px 0 0;
            .flashWrap {
              .up {
                margin: 0 0 10px 0;
                padding: 0 5px 0 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .title {
                  font-size: $font_size_big;
                }
                .time {
                  flex: 0 0 auto;
                }
              }
              .down {
                position: relative;
                width: 589px;
                height: 343px;
                .flash {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 10;
                }
                .placeholder_img {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 1;
                }
                /*.openFlash {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  font-size: $font_size_big;
                  .warnImg {
                    text-align: center;
                    img {
                      width: 100px;
                    }
                  }
                  .tips {
                    text-align: center;
                    p {
                      margin: 10px 0;
                    }
                    a {
                      color: $color_suc;
                    }
                  }
                }*/
              }
              .flashTipsImg {
                margin: 3px 0 0;
                a {
                  display: block;
                  height: 29px;
                }
                img {
                  height: 100%;
                }
              }
              .flashLines {
                padding: 10px 6px 0px 0px;
                font-size: 10px;
                .lines_key {
                  margin-bottom: 15px;
                  padding: 10px 0 5px 0;
                  border: 1px solid $color_line_images;
                  height: auto;
                  .col {
                    width: 33%;
                    float: left;
                    margin-bottom: 5px;
                  }
                  .block {
                    display: block;
                  }
                  .clear {
                    clear: both;
                    display: block;
                    overflow: hidden;
                    visibility: hidden;
                    width: 0;
                    height: 0;
                  }
                  .line_container {
                    float: left;
                    width: 80px;
                    height: 0;
                    border-top: 20px solid $color_white;
                    position: relative;
                    margin-left: 5px;
                  }
                  .line_container img {
                    display: block;
                    background: none;
                    float: left;
                    margin-top: -20px;
                  }
                }
              }
            }
            .detail {
              max-width: 595px;
              margin: 30px 0 0 0;
              .nav {
                padding: 0 0 15px 0;
                display: flex;
                align-items: center;
                font-size: $font_size_big;
                border-bottom: 1px solid $color_white;
                user-select: none;
                p {
                  margin: 0 50px 0 0;
                  cursor: pointer;
                }
                .active {
                  color: $color_suc;
                }
              }
              .intro {
                padding: 20px 0;
                font-size: $font_size_medium;
                line-height: 30px;
                word-break: break-all;
              }
              .goal {
                padding: 20px 0 0;
                .table {
                  width: 100%;
                  .tr {
                    width: 100%;
                    display: flex;
                  }
                  .td:first-child {
                    width: 30%;
                  }
                  .td:last-child {
                    width: 70%;
                  }
                  .td {
                    flex: 1 1 auto;
                    padding: 0 0 0 20px;
                    border: 1px solid $color_white;
                    .wrap {
                      height: 50px;
                      display: flex;
                      align-items: center;
                      img {
                        margin: 0 10px 0 0;
                      }
                    }
                  }
                }
              }
            }
          }
          .right {
            width: 25%;
            padding: 0 0 0 15px;
            border-left: 1px solid $color_white;
            user-select: none;
            p {
              width: 100%;
              font-size: $font_size_big;
            }
            .item {
              max-width: 189px;
              height: 40px;
              margin: 10px 0;
              padding: 0 0 0 10px;
              display: flex;
              align-items: center;
              cursor: pointer;
              span {
                over_hide();
              }
            }
            .active {
              background-color: $color_suc;
            }
          }
        }
      }
    }
  }
  
 
</style>

<style lang="stylus">
  .tag_tag{
    height  auto
    white-space normal
  }
  .out-buttons3d-box {
    margin-top: 300px !important;
  }
</style>
